/**
 * Guide books JS file.
 */

(function ($, Drupal, drupalSettings) {
  "use strict";
  /**
   * An example of Drupal behavior syntax.
   * We should create a new behavior to wrap different functionality.
   */
  Drupal.behaviors.exampleBehavior = {
    attach: function (context, settings) {
      // Code goes here.
      // Relevant functions can also go inside here.
    },
  };

  Drupal.behaviors.courseToggle = {
    attach: function (context, settings) {
      $(once("addCourseToggle", ".course-content-entity")).each(function () {
        const children = $(this).children("a");
        if (children.length > 4) {
          children.each(function (index) {
            if (index > 3) {
              $(this).addClass("extra");
              $(this).hide();
            }
          });
          const button = document.createElement("button");
          button.classList.add("course-toggle", "plain-link");
          button.innerHTML = "more lessons";
          button.setAttribute("aria-label", "show more lessons");
          $(this).append(button);

          button.addEventListener("click", function () {
            const extraElements = $(this).siblings(".extra");
            if (extraElements.is(":hidden")) {
              extraElements.show();
              this.innerHTML = "fewer lessons";
              this.classList.add("show-fewer");
              this.setAttribute("aria-label", "show fewer lessons");
            } else {
              extraElements.hide();
              this.innerHTML = "more lessons";
              this.classList.remove("show-fewer");
              this.setAttribute("aria-label", "show more lessons");
            }
          });
        }
      });
    },
  };
})(jQuery, Drupal, drupalSettings);
